import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { fetchJSON, postForm, postJSON } from '@haina/utils-request'
import { CRM_HOST } from '@/config'
import { isEmpty, isNotEmpty, prepareUrl, uniqWith } from '@haina/utils-commons'

const initialState = {
  customerList: [],
  contactList: [],
  socialList: [],
  orderList: [],
  customerDetail: {},
  customerSummary: '',
  customerMaster: '',
  orderProfile: {},
}

export const useCustomerProfileStore = create(
  devtools(
    (set, get) => ({
      ...initialState,

      reset: () => set(initialState),

      fetchCustomerList: async (input) => {

        return fetchJSON(`${CRM_HOST}/search_customers`, {keyword: input}).then((json) => {
          if (json.errcode === 0) {
            set(() => ({
              customerList: json.result,
            }))
            return json.result
          } else {
            throw new Error(json?.errmsg + ': ' + json.errcode)
          }
        })
      },

      fetchCustomerDetail: async (customerId) => {

        return fetchJSON(`${CRM_HOST}/get_customer_detail`, {customer_id: customerId}).then((json) => {
          if (json.errcode === 0) {
            set(() => ({
              customerDetail: json.result,
            }))
            return json.result
          } else {
            throw new Error(json?.errmsg + ': ' + json.errcode)
          }
        })
      },

      fetchCustomerSummary: async (customerId) => {

        return fetchJSON(`${CRM_HOST}/get_customer_summary`, {customer_id: customerId}).then((json) => {
          if (json.errcode === 0) {
            set(() => ({
              customerSummary: json.result??'',
            }))
            return json.result
          } else {
            throw new Error(json?.errmsg + ': ' + json.errcode)
          }
        })
      },

      fetchCustomerMaster: async (customerId) => {

        return fetchJSON(`${CRM_HOST}/get_customer_primary`, {customer_id: customerId}).then((json) => {
          if (json.errcode === 0) {
            set(() => ({
              customerMaster: json.result??'',
            }))
            return json.result
          } else {
            throw new Error(json?.errmsg + ': ' + json.errcode)
          }
        })
      },

      fetchContactList: async (customerId) => {

        return fetchJSON(`${CRM_HOST}/get_customer_contact`, {customer_id: customerId}).then((json) => {
          if (json.errcode === 0) {
            set(() => ({
              contactList: json.result,
            }))
            return json.result
          } else {
            throw new Error(json?.errmsg + ': ' + json.errcode)
          }
        })
      },

      fetchSocialList: async (customerId) => {

        return fetchJSON(`${CRM_HOST}/get_customer_social_media`, {customer_id: customerId}).then((json) => {
          if (json.errcode === 0) {
            set(() => ({
              socialList: json.result,
            }))
            return json.result
          } else {
            throw new Error(json?.errmsg + ': ' + json.errcode)
          }
        })
      },

      fetchOrderList: async (customerId) => {

        return fetchJSON(`${CRM_HOST}/get_customer_order`, {customer_id: customerId}).then((json) => {
          if (json.errcode === 0) {
            set(() => ({
              orderList: json.result,
            }))
            return json.result
          } else {
            throw new Error(json?.errmsg + ': ' + json.errcode)
          }
        })
      },

      fetchOrderProfile: async (orderSn) => {

        return fetchJSON(`${CRM_HOST}/get_customer_profile`, {order_sn: orderSn}).then((json) => {
          if (json.errcode === 0) {
            set(() => ({
              orderProfile: json.result,
            }))
            return json.result
          } else {
            throw new Error(json?.errmsg + ': ' + json.errcode)
          }
        })
      },

      mergeCustomerProfile: async (winner_id, loser_ids, operator_id) => {
        return Promise.reject('Not permitted')
        // return postJSON(`${CRM_HOST}/merge_customers`, {
        //   winner_id: winner_id,
        //   loser_ids: loser_ids,
        //   operator_id: operator_id,
        //   merge_reason: '重复客户',
        // }).then((json) => {
        //   if (json.errcode === 0) {
        //     return json.result
        //   } else {
        //     throw new Error(json?.errmsg + ': ' + json.errcode)
        //   }
        // })
      },

      splitCustomerProfile: async (customer_name, email_ids, operator_id) => {
        return Promise.reject('Not permitted')
        // return postJSON(`${CRM_HOST}/split_customer`, {
        //   customer_name: customer_name,
        //   email_ids: email_ids,
        //   operator_id: operator_id,
        // }).then((json) => {
        //   if (json.errcode === 0) {
        //     return json.result
        //   } else {
        //     throw new Error(json?.errmsg + ': ' + json.errcode)
        //   }
        // })
      },
    }),
    { name: 'customerProfile' },
  ),
)
